(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zb-baby-size-explainer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zb-baby-explainer')) {
    customElements.define(
      'zb-baby-explainer',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-zbe-track]');
          this.slides = Array.from(this.querySelectorAll('[data-zbe-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-zbe-dot]'));
          this.toggle = this.querySelector('[data-zbe-autoplay-toggle]');
          this.label = this.querySelector('[data-zbe-autoplay-label]');
          this.icon = this.querySelector('[data-zbe-autoplay-icon]');
          this.mobile = window.matchMedia('(max-width: 749px)');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.delay = Math.max(2000, Number(this.dataset.autoplayDelay) || 3000);
          this.activeIndex = 0;
          this.userPaused = this.dataset.mobileAutoplay !== 'true' || this.reducedMotion.matches;
          this.resumeTimer = 0;
          this.autoplayTimer = 0;
          this.scrollFrame = 0;

          if (!this.track || this.slides.length < 2) return;

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              this.userPaused = true;
              this.updateToggle();
              this.goTo(Number(dot.dataset.index), true);
            });
          });

          this.toggle?.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.updateToggle();
            this.schedule();
          });

          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.syncFromScroll());
          }, { passive: true });

          this.track.addEventListener('pointerdown', () => this.pauseTemporarily());
          this.track.addEventListener('pointerup', () => this.resumeLater());
          this.track.addEventListener('pointercancel', () => this.resumeLater());
          this.track.addEventListener('focusin', () => this.clearAutoplay());
          this.track.addEventListener('focusout', () => this.resumeLater());
          this.addEventListener('mouseenter', () => this.clearAutoplay());
          this.addEventListener('mouseleave', () => this.resumeLater());
          this.mobile.addEventListener('change', () => this.schedule());
          this.reducedMotion.addEventListener('change', () => {
            if (this.reducedMotion.matches) this.userPaused = true;
            this.updateToggle();
            this.schedule();
          });
          document.addEventListener('visibilitychange', () => this.schedule());

          this.updateToggle();
          this.schedule();
        }

        disconnectedCallback() {
          this.clearAutoplay();
          window.clearTimeout(this.resumeTimer);
          cancelAnimationFrame(this.scrollFrame);
        }

        clearAutoplay() {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = 0;
        }

        schedule() {
          this.clearAutoplay();
          if (
            this.userPaused ||
            !this.mobile.matches ||
            this.reducedMotion.matches ||
            document.hidden
          ) return;

          this.autoplayTimer = window.setTimeout(() => {
            this.goTo((this.activeIndex + 1) % this.slides.length, true);
            this.schedule();
          }, this.delay);
        }

        pauseTemporarily() {
          this.clearAutoplay();
          window.clearTimeout(this.resumeTimer);
        }

        resumeLater() {
          window.clearTimeout(this.resumeTimer);
          this.resumeTimer = window.setTimeout(() => this.schedule(), 4500);
        }

        goTo(index, smooth) {
          const target = this.slides[index];
          if (!target) return;
          this.track.scrollTo({
            left: target.offsetLeft,
            behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'auto'
          });
          this.setActive(index);
        }

        syncFromScroll() {
          const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const distance = Math.abs(trackCenter - slideCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.setActive(closestIndex);
        }

        setActive(index) {
          this.activeIndex = index;
          this.dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        updateToggle() {
          if (!this.toggle || !this.label || !this.icon) return;
          const paused = this.userPaused || this.reducedMotion.matches;
          this.label.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
          this.icon.textContent = paused ? '▶' : 'Ⅱ';
          this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
